import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { CommonModule } from '@angular/common';
import { DialogsService } from '../../../../../core/services/services';
import { CreatePayoutFromPaymentDialogComponent } from './create-payout-from-payment-dialog.component';
import { SharedModule } from '../../../../shared/shared.module';
import { LoadingModule } from '../../../../shared/loading/loading.module';

@NgModule({
  declarations: [CreatePayoutFromPaymentDialogComponent],
  imports: [
    MatRadioModule,
    MatDialogModule,
    FlexModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    TextMaskModule,
    MatSelectModule,
    CommonModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    SharedModule,
    MatButtonModule,
    LoadingModule,
  ],
  entryComponents: [CreatePayoutFromPaymentDialogComponent],
  providers: [DialogsService],
  exports: [CreatePayoutFromPaymentDialogComponent],
})
export class CreatePayoutFromPaymentDialogModule {}
